<app-abstract-action-confirmation-dialog
  (acceptEvent)="onAcceptClickedHandler()"
  (declineEvent)="onDeclineClickedHandler()"
  [acceptLabel]="data.acceptLabel"
  [declineLabel]="data.declineLabel"
  [formGroup]="formGroup"
  [formInvalidFlag]="formGroup.invalid"
  [messageLine1]="data.messageLine1"
  [messageLine2]="data.messageLine2"
  [subMessageLine1]="data.subMessageLine1"
  [subMessageLine2]="data.subMessageLine2"
>
  <div popup-form>
    <form [formGroup]="formGroup">
      <mat-form-field class="whole-width">
        <textarea
          [appFirstLetterUpperCase]="formGroup?.controls?.message"
          autocomplete="off"
          cdkAutosizeMaxRows="10"
          cdkAutosizeMinRows="5"
          cdkTextareaAutosize
          formControlName="message"
          matInput
          maxlength="4000"
          resize="none"
        ></textarea>
      </mat-form-field>
    </form>
  </div>
</app-abstract-action-confirmation-dialog>
